import { ColumnDef } from '@tanstack/react-table';
import React from 'react';
import no_img from '../../../assets/images/picture.png';
import { ArticleItemResponse } from '../../../context/models/articles/ArticleModel';
import { TableDefault } from '../../../components/common/Table';

export const RelatedArticles = () => {
	const columns = React.useMemo<ColumnDef<ArticleItemResponse>[]>(
		() => [
			{
				header: 'Tin bài',
				cell: ({ row }) => {
					const article = row.original;
					return (
						<div className='flex items-start gap-3 py-1'>
							<div className='hidden h-10 w-14 overflow-hidden rounded-md border bg-white md:block'>
								<img src={article.image ?? no_img} alt='ảnh đại diện' className='h-full w-full object-cover' />
							</div>
							<div className='min-w-0 flex-1'>
								<div className='line-clamp-2 text-sm font-medium text-foreground'>{article.title}</div>
							</div>
						</div>
					);
				},
				footer: (props) => props.column.id,
			},
			{
				accessorKey: 'catId',
				header: 'Chuyên mục',
				cell: ({ row }) => <span>{row.original.categoryName}</span>,
				meta: { width: 220, displayMode: 'tb-col-md' },
				footer: (props) => props.column.id,
			},
			// {
			// 	id: 'actions',
			// 	meta: { headerClass: 'text-center', columnClass: 'text-center', width: 40 },
			// 	cell: ({ row, table }) => <ArticleButtonTable row={row} table={table} onShowDetail={() => onShowDetail({ isShow: true, id: row.original.id })} />,
			// },
		],
		[]
	);
	return (
		<>
			<TableDefault
				refresh={() => {}}
				columns={columns}
				data={[]}
				keyFn='id'
			/>
		</>
	);
};
